/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { BUTTON_LIST_POSITION_RIGHT, ButtonListPosition } from '../ButtonList';
import { SdsDivProps } from '../Component.props';
import { FORM_LAYOUT_VERTICAL, FormLayout } from './types/FormLayout.types';
import { FORM_THEME_DEFAULT, FormTheme } from './types/FormTheme.types';

/**
 * The props for `<Form />`.
 */
export interface FormProps extends SdsDivProps {
  /**
   * A list of form button keys.
   */
  buttonKeys?: Array<string>;

  /**
   * A list of form buttons.
   */
  buttons?: Array<JSX.Element>;

  /**
   * Buttons position.
   */
  buttonsPosition?: ButtonListPosition;

  /**
   * The children of `<Form />`.
   */
  children: React.ReactNode;

  /**
   * Form error message.
   */
  errorMessage?: string;

  /**
   * Form layout.
   */
  layout?: FormLayout;

  /**
   * Form legend text.
   */
  legend: string;

  /**
   * Form theme.
   */
  theme?: FormTheme;
}

/**
 * The default prop values for `<Form />`.
 */
export const formPropsDefaults = {
  buttonKeys: [],
  buttons: [],
  buttonsPosition: BUTTON_LIST_POSITION_RIGHT as ButtonListPosition,
  children: null,
  errorMessage: ``,
  layout: FORM_LAYOUT_VERTICAL,
  theme: FORM_THEME_DEFAULT,
};
